<template>
  <div style="padding: 20px 0px 0px 20px;">

    <el-form style="display: flex;flex-wrap: wrap;">
      <el-form-item label="教师名称:" style="display: flex;width: 33%;">
        <el-select placeholder="请选择教师" v-model="input1" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList1" :key="item.id" :value="item.id" :label="item.realname"></el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="提交时间:" style="display: flex;width: 60%;">
        <el-date-picker v-model="input2" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" clearable>
        </el-date-picker>
      </el-form-item>


<!--  <el-form-item label="项目名称:" style="display: flex;width: 33%;">
        <el-select placeholder="请选择审批状态" v-model="input3" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList3" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item> -->


      <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
        <!-- <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-plus"
          @click="searchAddBtns">添加项目</el-button> -->
        <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
        <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search"
          @click="searchBtns">搜索</el-button>
        <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close"
          @click="clearBtns">清空</el-button>
      </div>

    </el-form>


    <el-table :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }" :data="dataList" border height="700">
      <el-table-column prop="teacherName" label="教师名称" show-overflow-tooltip></el-table-column>
      <el-table-column prop="integralSum" label="积分总数" show-overflow-tooltip></el-table-column>
      <!-- <el-table-column prop="classFee" label="添加时间" show-overflow-tooltip></el-table-column> -->
      <!-- <el-table-column prop="auditStatus" label="项目状态" show-overflow-tooltip>
        <template slot-scope="scope">
          <div style="display: flex;justify-content: space-around;color:rgb(255 54 0);"
            v-if="scope.row.auditStatus === 0">无效</div>
          <div style="display: flex;justify-content: space-around;color:rgb(23 226 31);"
            v-if="scope.row.auditStatus === 1">有效</div>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" fixed="right" width="200">
        <template slot-scope="scope">
          <div style="display: flex;justify-content: space-around;">
            <el-button type="text" style="color:#00aaff;" @click="handleClickView('详情', scope.row)">详情</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
      :page-size="pageSize" layout="prev, pager, next,sizes, jumper" :total="total">
    </el-pagination>

    <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false" :title="Titlecenter" :visible.sync="addShow" :before-close="closeEditDialog" width="80%">

      <el-form style="display: flex;flex-wrap: wrap;">
      <el-form-item label="项目名称:" style="display: flex;width: 33%;">
        <el-select placeholder="请选择项目名称" v-model="value1" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList5" :key="item.id" :value="item.id" :label="item.integralName"></el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="提交时间:" style="display: flex;width: 60%;">
        <el-date-picker v-model="value2" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" clearable>
        </el-date-picker>
      </el-form-item>


      <el-form-item label="审批时间:" style="display: flex;width: 60%;">
        <el-date-picker v-model="value3" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" clearable>
        </el-date-picker>
      </el-form-item>


      <el-form-item label="类型:" style="display: flex;width: 33%;">
        <el-select placeholder="请选择类型" v-model="value111" style="width: 100%" clearable filterable>
          <el-option v-for="item in optionList55" :key="item.id" :value="item.id" :label="item.integralName"></el-option>
        </el-select>
      </el-form-item>

    </el-form>

    <div style="margin: 20px 0px 0px 0px;">积分总数：<span style="color:red;">{{  integralCount }}</span></div>


    <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
      <!-- <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button> -->
      <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search"  @click="searchBtns1">搜索</el-button>
      <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns1">清空</el-button>
    </div>


    <el-table :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }" :data="dataList1" border height="700">
      <el-table-column prop="teacherName" label="教师名称" show-overflow-tooltip></el-table-column>
      <el-table-column prop="integralName" label="积分项目" show-overflow-tooltip></el-table-column>
      <el-table-column prop="integralType" label="类型" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.integralType === 1">新增</div>
          <div v-if="scope.row.integralType === 2">兑换</div>
        </template>
      </el-table-column>
      <el-table-column prop="applyForIntegral" label="分数" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createTime" label="提交时间" show-overflow-tooltip></el-table-column>
      <el-table-column prop="secondAuditDate" label="审批时间" show-overflow-tooltip></el-table-column>
    </el-table>

    <el-pagination style="text-align: center; margin: 20px;" @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page="pageNum1"
      :page-size="pageSize1" layout="prev, pager, next,sizes, jumper" :total="total1">
    </el-pagination>


    <div style="display: flex; margin-bottom: 20px; justify-content: end;">
      <el-button  type="primary" size="small" class="btns"   @click="handleClickViewBtn('取消')">取消</el-button>
    </div>


    </el-dialog>

  </div>
</template>


<script>
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import axios from "axios";
import apiBaseUrl from "../../config/api";
import { getTeachers } from "@/api/fiveClassApi"


export default {
  components: {

  },
  data() {
    return {

      value1: '',
      value2: [],
      value3: [],

      value111: '',

      integralCount: 0,


      inputValue1: '',
      inputValue2: 0 ,
      inputValue3: '',

      Titlecenter: '添加积分项目',
      optionList4: [{ id: 0, name: '无效' }, { id: 1, name: '有效' }],

      optionList1: [],
      optionList2: [],
      optionList3: [{ id: 0, name: '待审批' }, { id: 1, name: '驳回' }, { id: 2, name: '已完成' }],

      input1: '',
      input2: [],
      input3: '',

      dataList: [],

      pageNum: 1,
      pageSize: 10,
      total: 0,


      pageNum1: 1,
      pageSize1: 10,
      total1: 0,

      CourseCancellationComponentsType: '',
      CourseCancellationComponentsID: '',
      CourseCancellationComponentsShow: false,

      CourseCancellationomponentsTypeDistinguish: '课消审批',

      dataList1:[],


      addShow: false,

      inputID:'',

      optionList5:[],
      teacherIditme:null,

      optionList55:[
        {
          integralName: '新增',
          id: 1,
        },
        {
          integralName: '兑换',
          id: 2,
        }
      ],

    }
  },

  mounted() {
    getTeachers().then(res => { this.optionList1 = res.data })
    axios.get(`${apiBaseUrl}/questionnaire/queryCreator`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => { this.optionList2 = res.data.data })

    this.getApiList()
    this.handleintegralProject()
  },


  methods: {

    handleintegralProject(){
      axios.post(`${apiBaseUrl}/integralProject/findList`, { integralName:'' }, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data
          this.optionList5 = data
        } else {
          this.optionList5 = []
          this.$message.error(res.data.message)
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },

    handleClickViewBtn(type){

      if(type === '取消'){
          this.inputValue1 = ''
          this.inputValue2 = 0
          this.inputValue3 = ''
          this.Titlecenter = ''
          this.inputID = ''
          this.addShow = false
      }

      if(type === '确定'){

        if(this.inputValue1 === ''){
          this.$message.warning('请输入项目名称')
          return
        }

        if(this.inputValue3 === ''){
          this.$message.warning('请选择项目状态')
          return
        }

        let data = {
          name: this.inputValue1,
          score: this.inputValue2,
          status: this.inputValue3,
          id: this.inputID,
        }

      }

    },

    searchAddBtns() {
      this.Titlecenter = '添加积分项目'
      this.addShow = true
    },

    closeEditDialog() {
      this.Titlecenter = ''
      this.inputValue1 = ''
      this.inputValue2 = 0
      this.inputValue3 = ''
      this.inputID = ''

      this.value1 = ''
      this.value2 = []
      this.value3 = []

      this.addShow = false
    },

    CourseCancellationhandleEmit(e) {
      this.CourseCancellationComponentsShow = e
    },

    searchBtns() {
      this.getApiList()
    },

    searchBtns1() {
      this.getApiList1()
    },

    clearBtns1() {
      this.value1 = ''
      this.value111 = ''
      this.value2 = []
      this.value3 = []
      this.getApiList1()
    },


    clearBtns() {
      this.input1 = ''
      this.input2 = []
      this.input3 = ''
      this.input4 = ''
      this.getApiList()
    },

    exportBtns(){
      let data = {
        // pageNum: this.pageNum1,
        // pageSize: this.pageSize1,
        teacherId: this.input1,
        commitStartDate: (this.input2 && this.input2.length > 0) ? this.input2[0] + ' 00:00:00' : null,
        commitEndDate: (this.input2 && this.input2.length > 0) ? this.input2[1] + ' 00:00:00' : null,
        // auditStartDate: (this.value3 && this.value3.length > 0) ? this.value3[0] + ' 00:00:00' : null,
        // auditEndDate: (this.value3 && this.value3.length > 0) ? this.value3[1] + ' 00:00:00' : null,
        // integralId: this.value1,
      }
      axios.post(`${apiBaseUrl}/integralAudit/exportTeacherIntegral`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
           if(response.status == 200){
               const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })
               const downloadLink = document.createElement("a")
               downloadLink.href = URL.createObjectURL(blob)
               downloadLink.download = "积分详情.xlsx"
               downloadLink.click()
               this.$message({ message:'导出成功', type: "success" });
           } else{
              this.$message.error('导出失败')
           }
       }).catch((err) => {
          this.$message.error(err)
      })
    },


    getApiList1() {
      let data = {
        pageNum: this.pageNum1,
        pageSize: this.pageSize1,
        teacherId: this.teacherIditme.teacherId,
        commitStartDate: (this.value2 && this.value2.length > 0) ? this.value2[0] + ' 00:00:00' : null,
        commitEndDate: (this.value2 && this.value2.length > 0) ? this.value2[1] + ' 00:00:00' : null,
        auditStartDate: (this.value3 && this.value3.length > 0) ? this.value3[0] + ' 00:00:00' : null,
        auditEndDate: (this.value3 && this.value3.length > 0) ? this.value3[1] + ' 00:00:00' : null,
        integralId: this.value1,
        integralType: this.value111,
      }
      axios.post(`${apiBaseUrl}/integralAudit/findTeacherIntegralPage`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data
          this.dataList1 = data.records.records
          this.pageNum1= data.records.current ? data.records.current : 1
          this.pageSize1 = data.records.size ? data.records.size : 10
          this.total1 = data.records.total ? data.records.total : 0
          this.integralCount = data.integralCount

          if(data.records && data.records.records.length < 0){
            this.dataList1 = []
          }

          this.$message({ message:res.data.message, type: "success" });
        } else {

          this.$message.error(res.data.message)
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },

    getApiList() {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        teacherId: this.input1,
        commitStartDate: (this.input2 && this.input2.length > 0) ? this.input2[0] + ' 00:00:00' : null,
        commitEndDate: (this.input2 && this.input2.length > 0) ? this.input2[1] + ' 00:00:00' : null,
      }
      axios.post(`${apiBaseUrl}/integralAudit/findTeacherIntegralSumPage`, data, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data
          this.dataList = data.records
          this.pageNum = data.current ? data.current : 0
          this.pageSize = data.size ? data.size : 10
          this.total = data.total ? data.total : 0

          if(data.records && data.records.length < 0){
            this.dataList = []
          }

          this.$message({ message:res.data.message, type: "success" });
        } else {
          this.$message.error(res.data.message)
        }
      }).catch((err) => {
        this.$message.error(err)
      })
    },

    handleSizeChange(e) {
      this.pagepageSizeNum = e
      this.getApiList()
    },

    handleSizeChange1(e) {
      this.pageSize1 = e
      this.getApiList1()
    },


    handleCurrentChange(e) {
      this.pageNum = e
      this.getApiList()
    },


    handleCurrentChange1(e) {
      this.pageNum1= e
      this.getApiList1()
    },

    handleClickView(type, itme) {

      if (type === '编辑') {
        console.log(itme)
        this.Titlecenter = '编辑积分项目'

        this.inputValue1 = itme.inputValue1
        this.inputValue2 = itme.inputValue2
        this.inputValue3 = itme.inputValue3
        this.inputID = itme.id

        this.addShow = true

      }

      if (type === '详情') {
        console.log(itme)
        this.Titlecenter = '积分详情'

        // this.inputValue1 = itme.inputValue1
        // this.inputValue2 = itme.inputValue2
        // this.inputValue3 = itme.inputValue3
        // this.inputID = itme.id

        this.teacherIditme = itme

        this.addShow = true

        this.getApiList1()


      } else {
        this.CourseCancellationComponentsType = type
        this.CourseCancellationComponentsID = itme.id
        this.CourseCancellationComponentsShow = true

        this.$nextTick(() => {
          this.$refs.CourseCancellationomponents.handleInit(itme.id)
        })
      }


    },


  }

}
</script>


<style scoped lang="less">
.no-click {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/PointsManagement/PointsDetails.vue